import React, { useEffect } from "react";
import { Table, TableBody, TableCell, TableHead, TablePagination, TableRow } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import HeadCell from "../table/HeadCell";
import style from "./UserList.module.css";
import { useApi } from "../../../../common/hooks";
import { LicenceManagementService } from "../../../../api";
import { setSelectedUserLicenceManagement, setUpdateLicenceManagement } from "../../../../common/slice";
import LoadingOverlay from "../../../../common/components/loaders/LoadingOverlay";
import { translate } from "../../../../common/providers";
import { isNonEmptyArray } from "../../../../common/utils";

export default function UserList() {
	const licenceManagementStore = useSelector(({ context }) => context.licenceManagement);
	const selectedUser = useSelector(({ context }) => context.licenceManagement?.selectedUser);
	const dispatch = useDispatch();

	const [isLoading, setIsLoading] = React.useState(false);

	const { call: getListUsers } = useApi(LicenceManagementService.getListUsers);
	const getBodyTable = (params) => {
		setIsLoading(true);
		getListUsers(params)
			.then((data) => {
				if (!selectedUser && isNonEmptyArray(data.contents)) {
					dispatch(setSelectedUserLicenceManagement({ user: data.contents[0] }));
				}
				setIsLoading(false);
				dispatch(setUpdateLicenceManagement({ listUsers: data }));
			})
			.catch((e) => {
				console.error(e);
				setIsLoading(false);
			});
	};
	const preparePayload = () => {
		let payload = { username: "" };

		payload = {
			sort: licenceManagementStore.sort,
			username: licenceManagementStore.search?.searchUserName,
			direction: licenceManagementStore.direction,
		};

		return payload;
	};

	useEffect(() => {
		dispatch(setUpdateLicenceManagement({ page: 0 }));
		const payload = preparePayload();
		const params = { page: 0, limit: licenceManagementStore.rowsPerPage, payload };
		getBodyTable(params);

		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [
		licenceManagementStore?.search?.searchUserName,
		licenceManagementStore?.sort,
		licenceManagementStore?.direction,
		licenceManagementStore.rowsPerPage,
	]);

	const handleChangePage = (event, newPage) => {
		dispatch(setUpdateLicenceManagement({ page: newPage }));
		const payload = preparePayload();
		const params = {
			page: newPage,
			limit: licenceManagementStore.rowsPerPage,

			payload,
		};

		getBodyTable(params);
	};

	const handleChangeRowsPerPage = (event) => {
		dispatch(setUpdateLicenceManagement({ rowsPerPage: event.target.value, page: 0 }));
		const payload = preparePayload();
		const params = { page: 0, limit: event.target.value, payload };
		getBodyTable(params);
	};
	const handelSelectUser = (user) => {
		if (selectedUser.id === user.id) {
			return;
		}
		dispatch(setSelectedUserLicenceManagement({ user }));
	};
	const handelUpdateSort = (item) => {
		dispatch(
			setUpdateLicenceManagement({
				sort: item,
				direction: licenceManagementStore?.direction === "ASC" ? "DESC" : "ASC",
			})
		);
	};
	return (
		<>
			{isLoading && <LoadingOverlay />}
			<div className={style.tableContainer}>
				<Table className={style.table}>
					<TableHead className={style.tableHead}>
						<HeadCell
							cell={{ name: translate("license-management.users-list.user") }}
							className={style.cellHeadC1}
							onClick={() => handelUpdateSort("name")}
						/>
						<HeadCell
							cell={{ name: translate("license-management.users-list.email") }}
							className={style.cellHeadC2}
							onClick={() => handelUpdateSort("email")}
						/>
						<HeadCell
							hiddenSort
							cell={{ name: translate("license-management.users-list.profile") }}
							className={style.cellHeadC3}
						/>
					</TableHead>
					<TableBody>
						{licenceManagementStore?.listUsers?.contents?.map((user) => (
							<TableRow
								className={`${style.cursorPointer} ${style.tableRow}  ${
									user?.id === licenceManagementStore?.selectedUser?.id ? style.selectedCell : ""
								}  ${user?.userStatus !== "ACTIVE" ? style.blockedCell : ""} `}
								data-testid={`user.row.${user.displayName}`}
								onClick={() => handelSelectUser(user)}
							>
								<TableCell className={`${style.tableCellRow} ${style.noBorderLeft}`}>
									{user?.displayName}
								</TableCell>
								<TableCell className={style.tableCellRow}>{user?.email}</TableCell>
								<TableCell
									className={`${style.tableCellRow} ${style.noBorderRight}`}
									data-testid={`user.status.${user.displayName}`}
								>
									{user?.userStatus === "ACTIVE" ? user?.profil : user?.userStatus}
								</TableCell>
							</TableRow>
						))}
					</TableBody>
				</Table>
			</div>
			<TablePagination
				component="div"
				count={licenceManagementStore?.listUsers?.totalElements}
				labelRowsPerPage={translate("common:pagination.row-per-page")}
				page={licenceManagementStore?.page || 0}
				rowsPerPage={licenceManagementStore?.rowsPerPage}
				rowsPerPageOptions={[25, 50, 75]}
				onPageChange={handleChangePage}
				onRowsPerPageChange={handleChangeRowsPerPage}
			/>
		</>
	);
}
